// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var hasRuntimeTypeRecordRLNil = {
    hasRuntimeTypeRecRL: function (v) {
        return function (v1) {
            return true;
        };
    }
};
var hasRuntimeTypeRecRL = function (dict) {
    return dict.hasRuntimeTypeRecRL;
};
var hasRuntimeTypeNull = {
    hasRuntimeType: function (v) {
        return Foreign.isNull;
    }
};
var hasRuntimeTypeInt = {
    hasRuntimeType: function (v) {
        return $foreign.isInt;
    }
};
var hasRuntimeTypeForeign = {
    hasRuntimeType: function (v) {
        return function (v1) {
            return true;
        };
    }
};
var hasRuntimeType = function (dict) {
    return dict.hasRuntimeType;
};
var hasRuntimeTypeRecordRLCons = function (dictHasRuntimeTypeRecordRL) {
    var hasRuntimeTypeRecRL1 = hasRuntimeTypeRecRL(dictHasRuntimeTypeRecordRL);
    return function (dictHasRuntimeType) {
        var hasRuntimeType1 = hasRuntimeType(dictHasRuntimeType);
        return function (dictIsSymbol) {
            var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
            return {
                hasRuntimeTypeRecRL: function (v) {
                    return function (x) {
                        var propertyName = reflectSymbol(Type_Proxy["Proxy"].value);
                        var property = $foreign.getProperty(propertyName)(x);
                        var hasRuntimeTypeA = hasRuntimeType1(Type_Proxy["Proxy"].value);
                        return hasRuntimeTypeA(property) && hasRuntimeTypeRecRL1(Type_Proxy["Proxy"].value)(x);
                    };
                }
            };
        };
    };
};
var newtypeHasRuntimeType = function () {
    return function (dictHasRuntimeType) {
        var hasRuntimeType1 = hasRuntimeType(dictHasRuntimeType);
        return function (v) {
            return hasRuntimeType1(Type_Proxy["Proxy"].value);
        };
    };
};
var hasJsType = function (name) {
    return function (x) {
        return Foreign.typeOf(x) === name;
    };
};
var hasRuntimeTypeBoolean = {
    hasRuntimeType: function (v) {
        return hasJsType("boolean");
    }
};
var hasRuntimeTypeNumber = {
    hasRuntimeType: function (v) {
        return hasJsType("number");
    }
};
var hasRuntimeTypeObject = function (dictHasRuntimeType) {
    var hasRuntimeType1 = hasRuntimeType(dictHasRuntimeType);
    return {
        hasRuntimeType: function (v) {
            return function (x) {
                var hasRuntimeTypeE = hasRuntimeType1(Type_Proxy["Proxy"].value);
                return hasJsType("object")(x) && Foreign_Object.all(function (v1) {
                    return hasRuntimeTypeE;
                })(x);
            };
        }
    };
};
var hasRuntimeTypeRecord = function () {
    return function (dictHasRuntimeTypeRecordRL) {
        var hasRuntimeTypeRecRL1 = hasRuntimeTypeRecRL(dictHasRuntimeTypeRecordRL);
        return {
            hasRuntimeType: function (v) {
                return function (x) {
                    return hasJsType("object")(x) && hasRuntimeTypeRecRL1(Type_Proxy["Proxy"].value)(Foreign.unsafeToForeign(x));
                };
            }
        };
    };
};
var hasRuntimeTypeString = {
    hasRuntimeType: function (v) {
        return hasJsType("string");
    }
};
var hasRuntimeTypeUndefined = {
    hasRuntimeType: function (v) {
        return hasJsType("undefined");
    }
};
var cast = function (dictHasRuntimeType) {
    var hasRuntimeType1 = hasRuntimeType(dictHasRuntimeType);
    return function (x) {
        var hasRuntimeTypeA = hasRuntimeType1(Type_Proxy["Proxy"].value);
        var $33 = hasRuntimeTypeA(Foreign.unsafeToForeign(x));
        if ($33) {
            return new Data_Maybe.Just(x);
        };
        return Data_Maybe.Nothing.value;
    };
};
export {
    hasRuntimeType,
    newtypeHasRuntimeType,
    hasRuntimeTypeRecRL,
    cast,
    hasRuntimeTypeUndefined,
    hasRuntimeTypeNull,
    hasRuntimeTypeBoolean,
    hasRuntimeTypeInt,
    hasRuntimeTypeNumber,
    hasRuntimeTypeString,
    hasRuntimeTypeForeign,
    hasRuntimeTypeObject,
    hasRuntimeTypeRecord,
    hasRuntimeTypeRecordRLNil,
    hasRuntimeTypeRecordRLCons
};
//# sourceMappingURL=index.js.map
